import { type StartRequest, type CreateSessionResponse, type FinishResponse } from "../types/api.js";
import { withCSRF } from "./_csrf.js";

export async function startSession(req: StartRequest): Promise<CreateSessionResponse> {
  const res = await fetch("/api/sessions", {
    method: "POST",
    credentials: "include",
    headers: withCSRF({ "Content-Type": "application/json" }),
    body: JSON.stringify(req),
  });
  if (!res.ok) throw new Error(`startSession: ${res.status}`);
  return res.json() as Promise<CreateSessionResponse>;
}

export async function finishSession(sessionId: string): Promise<FinishResponse> {
  const res = await fetch(`/api/sessions/${encodeURIComponent(sessionId)}/finish`, {
    method: "POST",
    credentials: "include",
    headers: withCSRF(),
  });
  if (!res.ok) throw new Error(`finishSession: ${res.status}`);
  return res.json() as Promise<FinishResponse>;
}
